import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { useState, useEffect } from "react";
import { MyFetch } from "../../App";
import InputGroup from 'react-bootstrap/InputGroup'; // Import InputGroup for combining input with button
import { useLocation, useNavigate } from 'react-router-dom';


const EmployeeForm = (props) => {
  const [validated, show_Validation] = useState(false);
  const [showPassword, setShowPassword] = useState(false); // State to manage password visibility
  const navigate = useNavigate();

  const [form_Data, set_Form_Data] = useState({
    name: "k",
    mobile: "1234567890",
    email: "k@gmail.com",
    // address: "",
    city: "kol",
    position: "k123456",
    password: "k123456"
  });

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };
  const submitFn = (event) => {
    event.preventDefault(); // Prevent the default form submission behavior
    const form = event.currentTarget; // Get the form element

    if (form.checkValidity() === false) {
      event.stopPropagation(); // Stop the form from submitting if validation fails
    } else {
      MyFetch("https://easytasks.in/employee/create", form_Data, "POST")
        .then((res) => res.json())
        .then((data) => {
          set_Form_Data({
            name: "",
            mobile: "",
            email: "",
            address: "",
            city: "",
          }); // Clear the form data after successful submission
          alert("Employee created successfully!")
          navigate('/employee/list'); // Notify the user; // Notify the user
        })
        .catch((error) => {
          console.error("Error creating employee:", error);
          alert("Failed to create employee."); // Notify the user of any errors
        });
    }

    show_Validation(true); // Trigger validation feedback styling
  }



  const chngFn = (event) => {
    const { name, value } = event.target;
    set_Form_Data({
      ...form_Data,
      [name]: value,
    });
  };

  return (

    <Container className='mt-5'>
      <Row className="justify-content-md-center">
        <Col xs lg="5" >
          <h2 className='my-5'><b>ADD AN EMPLOYEE</b></h2>
        </Col>
      </Row>
      <Row className="justify-content-md-center">
        <Col xs lg="5">
          <Form noValidate validated={validated} onSubmit={submitFn}>

            <Form.Group className="mb-3" controlId="employeeName">
              <Form.Label>Name</Form.Label>
              <Form.Control
                type="text"
                name="name"
                value={form_Data.name}
                onChange={chngFn}
                pattern="^[a-zA-Z0-9 ]+$"
                required
                isInvalid={
                  validated &&
                  !/^[a-zA-Z0-9 ]+$/.test(form_Data.name)
                }
              />
              <Form.Control.Feedback type="invalid">
                Please enter a valid username (alphanumeric
                characters only).
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-3" controlId="employeeMobile">
              <Form.Label>Mobile</Form.Label>
              {/* check validation - it is showing tick even though it is invalid */}
              <Form.Control
                type="number"
                name="mobile"
                value={form_Data.mobile}
                onChange={chngFn}
                pattern="^\d{10}$"
                required
                isInvalid={
                  validated &&
                  !/^\d{10}$/.test(form_Data.mobile)
                }
              />
              <Form.Control.Feedback type="invalid">
                Please enter a valid 10-digit phone number.
              </Form.Control.Feedback>
            </Form.Group>


            <Form.Group className="mb-3" controlId="employeeEmail">
              <Form.Label>Email</Form.Label>
              <Form.Control
                placeholder="name@example.com"
                type="email"
                name="email"
                value={form_Data.email}
                onChange={chngFn}
                required
                isInvalid={
                  validated &&
                  !/^\S+@\S+\.\S+$/.test(form_Data.email)
                }
              />
              <Form.Control.Feedback type="invalid">
                Please enter a valid email address.
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-3" controlId="employeePassword">
              <Form.Label>Set Login Password</Form.Label>
              <InputGroup>
                <Form.Control
                  type={showPassword ? 'text' : 'password'}
                  name="password"
                  value={form_Data.password}
                  onChange={chngFn}
                  pattern="^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$"
                  required
                  isInvalid={
                    validated &&
                    !/^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$/.test(form_Data.password)
                  }
                />
                <Button variant="outline-secondary" onClick={togglePasswordVisibility}>
                  {showPassword ? 'Hide' : 'Show'}
                </Button>
                <Form.Control.Feedback type="invalid">
                  Please enter a valid password (at least 8 characters, including both letters and numbers).
                </Form.Control.Feedback>
              </InputGroup>
            </Form.Group>


            <Form.Group className="mb-3" controlId="employeeCity">
              <Form.Label>City</Form.Label>
              <Form.Control
                type="text"
                name="city"
                value={form_Data.city}
                onChange={chngFn}
                pattern="^[a-zA-Z]+$"
                required
                isInvalid={
                  validated &&
                  !/^[a-zA-Z]+$/.test(form_Data.city)
                }
              />
              <Form.Control.Feedback type="invalid">
                Please enter a valid city (alphabets only).
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-3" controlId="employeePosition">
              <Form.Label>Position</Form.Label>
              <Form.Select aria-label="Default select example"
                type="text"
                name="position"
                value={form_Data.position}
                onChange={chngFn}>
                <option>Open this select menu</option>
                <option value="Employee">Employee</option>
                <option value="Middle-Management">Middle Management</option>
                <option value="Manager">Manager</option>
              </Form.Select>
              <Form.Control.Feedback type="invalid">
                Please enter a valid city (alphabets only).
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-3" controlId="employeeMode">
              <Form.Label>Mode</Form.Label>
              <Form.Select aria-label="Default select example"
                type="text"
                name="mode"
                value={form_Data.mode}
                onChange={chngFn}>
                <option>Open this select menu</option>
                <option value="Employee">Remote</option>
                <option value="Client-Site">Client-Site</option>
                <option value="In-Office">In-Office</option>
              </Form.Select>
              <Form.Control.Feedback type="invalid">
                Please enter a valid city (alphabets only).
              </Form.Control.Feedback>
            </Form.Group>

            <Button variant="primary" type="submit">
              Create
            </Button>
          </Form>
        </Col>
      </Row>
    </Container>
  );
}

export default EmployeeForm;